import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { bridge } from 'shared/src/utils';

export const useEditFoldersOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likedFolderService.editOrder,
    throwOnError: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.getInfiniteLikeFolders,
      });
    },
    onError: error => bridge.toast(error.message || '오류가 발생했어요'),
  });
};
